import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ScatterPeriod } from 'src/app/models/obs/scatterPeriod';
import { ScatterPeriodService } from 'src/app/services/obs/scatter-period.service';

@Component({
  selector: 'app-adm-modal-scatter-period',
  templateUrl: './adm-modal-scatter-period.component.html',
  styleUrl: './adm-modal-scatter-period.component.scss'
})
export class AdmModalScatterPeriodComponent implements OnInit {

  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Input() showModal: boolean;
  @Input() idTier1: string;

  form: FormGroup;
  scatterPeriod: ScatterPeriod = null;
  listPeriods: any[] = [];
  edit: boolean = false;

  initialFormValues: any

  constructor(
    private scatterPeriodS: ScatterPeriodService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createForm();
    this.getAllScatterPeriod();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idtier1: [this.idTier1, Validators.required],
      period: ['', Validators.required],
      description: ['', Validators.required],
      xi: [0],
      xf: [5],
      yi: [0],
      yf: [5],
      status: [true],
      url: ['', Validators.required] //validar campo 2025
    });
    this.initialFormValues = this.form.value;
  }

  getAllScatterPeriod() {
    this.scatterPeriodS.getAllByIdT14Admin(this.idTier1).subscribe({
      next: res => { this.listPeriods = res['data']; },
      error: err => { }
    })
  }

  editScatterPeriod(scatterPeriod: ScatterPeriod) {
    this.form.patchValue(scatterPeriod);
    this.scatterPeriod = scatterPeriod;
    this.edit = true;
  }

  save() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    }
    this.saveOrUpdate();
  }

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
  }

  create(scatterPeriod: ScatterPeriod) {
    delete scatterPeriod.id;
    this.scatterPeriodS.create(scatterPeriod).subscribe({
      next: res => {
        this.loadData();
        this.emmitSaveToParent()
      },
      error: err => { console.error(err) }
    });
  }

  update(id: string, scatterPeriod: ScatterPeriod) {
    delete scatterPeriod.id;
    this.scatterPeriodS.update(id, scatterPeriod).subscribe({
      next: res => { this.loadData(); },
      error: err => { console.error(err) }
    });
  }

  loadData() {
    this.getAllScatterPeriod();
    this.clearForm();
  }


  clearForm() {
    this.form.reset();
    this.edit = false;
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }


  closeModal() {
    this.onClose.emit();
  }

  cancel() {
    this.afterSaveOrUpdate();
  }

  emmitSaveToParent() {
    this.onSave.emit();
  }

  afterSaveOrUpdate() {
    this.form.setValue(this.initialFormValues);
    this.edit = false;
  }

}
